import { render, staticRenderFns } from "./MarketplaceProductDetail.vue?vue&type=template&id=3e047004&scoped=true&"
import script from "./MarketplaceProductDetail.vue?vue&type=script&lang=js&"
export * from "./MarketplaceProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceProductDetail.vue?vue&type=style&index=0&id=3e047004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e047004",
  null
  
)

export default component.exports